import HomeBrowse from '../../views/helpCenter/home/homeBrowse';

const hydrate = component => {
  const { clientName: name } = component;
  const props =  window.__PROPS__ && window.__PROPS__[name];
  const reactElement = React.createElement(component, props);
  const domElement = document.getElementById(`react-${name}`);
  if (domElement) {
    window.ReactDOM.hydrate(reactElement, domElement);
  }
};

hydrate(HomeBrowse);
